import React, { useCallback } from 'react';
import { createReactiveContext } from '../../../../../helpers/reactiveContext';
import { FLAT_TYPE_ID } from '../../../shared/configs/address';

const { Provider, useMethods, useSelector } = createReactiveContext();

const initialState = {
  relatedRooms: [],
  relatedIds: new Set(),
  hasRelatedFlat: false,
};

const RelatedRoomsProvider = ({ children }) => {
  return <Provider initialState={initialState}>{children}</Provider>;
};

const useRelatedRoomIds = () => useSelector((state) => state.relatedIds);
const useHasRelatedRooms = () =>
  useSelector((state) => {
    return state.relatedIds?.size > 0;
  });
const useHasRelatedFlat = () =>
  useSelector((state) => {
    return state.hasRelatedFlat ?? false;
  });

const useRelatedRoomsActions = () => {
  const { setState, getState, getValue, reset } = useMethods();

  const onChange = useCallback(
    (value, room) => {
      const relatedRooms = getValue('relatedRooms');

      const newRelatedRooms = value
        ? [...relatedRooms, room]
        : relatedRooms.filter((r) => r.id !== room.id);

      let hasRelatedFlat = false;
      const newRelatedIds = new Set();

      newRelatedRooms.forEach((room) => {
        newRelatedIds.add(room.id);
        if (room.typeId === FLAT_TYPE_ID && !hasRelatedFlat) {
          hasRelatedFlat = true;
        }
      });

      setState({
        relatedRooms: newRelatedRooms,
        relatedIds: newRelatedIds,
        hasRelatedFlat,
      });
    },
    [getValue, setState]
  );

  return { onChange, getState, reset };
};

export {
  RelatedRoomsProvider,
  useRelatedRoomIds,
  useRelatedRoomsActions,
  useHasRelatedRooms,
  useHasRelatedFlat,
};
